<template>
  <div id="app">
    <el-container>
      <!-- <el-header> -->
      <!-- </el-header> -->
      <el-main>
        <!-- <div class="cut">
          <div class="cut-function">
            <img src="../src/assets/newoeimg/register.png" alt="" />
            <p>免费注册</p>
          </div>
          <div class="cut-function">
            <img src="../src/assets/newoeimg/down.png" alt="" />
            <p>下载软件</p>
          </div>
          <div class="cut-function">
            <img src="../src/assets/newoeimg/kefu1.png" alt="" />
            <p>官方客服</p>
          </div>
          <div class="cut-function">
            <img src="../src/assets/newoeimg/kefu2.png" alt="" />
            <p>电报客服</p>
          </div>
        </div> -->
        <router-view />
      </el-main>
    </el-container>
  </div>
</template>

<script>
  export default {
    name: "App",
    data() {
      return {
        maskShow: false,
        router: true,
        defaultActive: "/",
        isShow: true,
        landtype: "en",
        headerList: [{
          title: '首页',
          index: 0,
          path: '/'
        }, {
          title: '软件功能',
          index: 1,
          path: 'SoftFunction'
        }, {
          title: '定价标准',
          index: 2,
          path: 'PricingStandards'
        }, {
          title: '使用文档',
          index: 3,
          path: 'UsingDocuments'
        }, {
          title: '联系我们',
          index: 4,
          path: 'ContactUs'
        }, {
          title: '个人中心',
          index: 5
        }, {
          title: '计数器',
          index: 6
        }],
        changIndex: ''
      };
    },
    created() {
      if (sessionStorage.getItem('changIndex')) {
        this.changIndex = sessionStorage.getItem('changIndex')
      } else {
        this.changIndex = ''
      }

      if (localStorage.getItem("lang")) {
        this.landtype = localStorage.getItem("lang");
      }
    },
    mounted() {},
    methods: {
      cutLand(type) {
        if (type == "en") {
          this.landtype = "tw-cn";
          localStorage.setItem("lang", "tw-cn");
          this.$message({
            message: "切换成功！",
            type: "success"
          });
        } else {
          this.landtype = "en";
          localStorage.setItem("lang", "en");
          this.$message({
            message: "Switch successful！",
            type: "success"
          });
        }
        location.reload()
      },
      // 打开窗口
      openShow() {
        this.maskShow = true;

      },
      showMask() {
        this.maskShow = false;
      },
      handleSelect(key) {
        this.isShow = this.defaultActive != key;
        this.maskShow = false;
      },
      changRouer(item) {
        sessionStorage.setItem('changIndex', item.index)
        this.changIndex = sessionStorage.getItem('changIndex')
        this.$router.push({
          path: item.path
        })
        this.isShow = true
      },
      goLogin() {
        this.$router.push({
          path: 'Login'
        })
      }
    }
  };
</script>
<style lang="scss">
  @import "./assets/scss/App.scss";

  .changClass {
    color: #80deea;
    position: relative;
  }

  .changClass::after {
    content: "";
    position: absolute;
    top: 20px;
    left: 0;
    right: 0;
    height: 4px;
    border-radius: 2px;
    background-color: #80deea;
  }

  //修改首页走马灯
  .slide-one .el-carousel__container {
    height: 100%;
  }

  .slide-one .el-carousel__arrow--left {
    width: 64px;
    height: 64px;
    background-color: rgba(255, 255, 255, .2);
    opacity: 1;
  }

  .slide-one .el-carousel__arrow--right {
    width: 64px;
    height: 64px;
    background-color: rgba(255, 255, 255, .2);
    opacity: 1;
  }


  /* 隐藏左箭头按钮 */
  .slide-newoe-three .el-carousel__arrow--left {
    display: none;
  }

  /* 隐藏右箭头按钮 */
  .slide-newoe-three .el-carousel__arrow--right {
    display: none;
  }

  /* 隐藏指示器 */
  .slide-newoe-three .el-carousel__indicators {
    display: none;
  }

  .el-progress__text {
    white-space: pre; //使百分号与所添加文字换行
  }

  .custom-message-box-width {
    width: 600px;
    /* 设置为所需宽度 */
  }

  .rc-step .el-step__title {
    font-size: 14px;
  }

  .inputStyle .el-input__inner:focus {
    border-color: #80deea; // 替换为你想要的边框颜色
  }

  .pageStyle .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #80deea;
    color: #FFF;
  }

  .pageStyle .el-pagination__sizes .el-input .el-input__inner:hover {
    border-color:#80deea;
    // border:1px solid #80deea;
  }

  .pageStyle .el-input__inner:focus {
    outline: none;
    border-color: #80deea !important;
  }

  .pageStyle .el-select .el-input.is-focus .el-input__inner {
    border-color: #80deea;
  }

  .pageStyle .el-pagination.is-background .el-pager li:not(.active):hover {
    color: #80deea  ;
    border:1px solid #80deea;
  }

  .inputStyle .el-radio__input.is-checked .el-radio__inner {
    border-color: #80deea  ;
    background: #80deea  ;
  }

  .inputStyle .el-radio__input.is-checked+.el-radio__label {
    color: #80deea   ;
  }


  .inputStyle .el-select-dropdown__item.selected {
    color: #80deea   ;
    font-weight: 700;
  }

  .inputStyle .el-textarea__inner:focus {
    outline: none;
    border-color: #80deea !important;
  }


</style>



// WEBPACK FOOTER //
// src/App.vue